<script>
    import { navigateTo } from 'svelte-router-spa'
    import { visitor } from '../../store.js'

    function nxt() {
        visitor.set('YES')
        navigateTo('purpose')
    }
</script>

<main>
    <div class="body">
        <h1>Are you an employee or visitor?</h1>
        <a class="btn" href="/idNumber">
            <span class="e">Employee</span>
            <span class="f">Empleado</span>
        </a>
        <a class="btn" on:click={nxt}>
            <span class="e">Visitor</span>
            <span class="f">Bisita</span>
        </a>
    </div>
</main>